import React, { Fragment, useEffect, useState, useCallback } from 'react'
import {
    DataGrid, GridToolbarContainer,
    GridToolbarExport,
    gridClasses,
} from '@mui/x-data-grid';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import AddIcon from '@mui/icons-material/Add'
import Documents from '../Utilities/documents';
import Remarks from '../Utilities/remarks';
import { GetWaitListById, AddDocument, AddRemark, ModifyWaitListApplicant, DeleteWaitListApplicant, CreateAccount, GetWaitListByType, GetWaitLists } from '../../REST/waitList';
import { GetPropertyTypes } from '../../REST/properties';
import moment from 'moment';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import IconButton from '@mui/material/IconButton';
import ChatIcon from '@mui/icons-material/ChatBubble';
import ArrowRight from '@mui/icons-material/ArrowRight';
import MessageDialog from '../Messages';
import BackIcon from '@mui/icons-material/ArrowBack';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import EmailIcon from '@mui/icons-material/Email';
import * as yup from "yup";
import { CreateWaitlistInvoice } from '../../REST/invoices'
import { handleErr } from '../../helpers/errors'
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import { Box, CircularProgress, Button, Chip } from '@mui/material';
import { Routes, Route, useNavigate, useLocation, useParams } from 'react-router-dom'
import AuthProvider from '../Authentication/authProvider';
import Access from '../../Utils/authorize';
import SendTemplateDialog from '../../themes/components/SendTemplateDialog';
import FormHelperText from '@mui/material/FormHelperText';
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import NativeSelect from '@mui/material/NativeSelect';
import CloseIcon from '@mui/icons-material/Close'; 
import Typography from '@mui/material/Typography';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import SaveOutlined from "@mui/icons-material/SaveOutlined";
import PageShell from '../../themes/components/PageShell';
import PageHeader from '../../themes/components/PageHeader';
import PageContent from '../../themes/components/PageContent';
import Action from '../../themes/components/Action';
import ResponsiveDataGrid from '../../themes/components/ResponsiveDataGrid';

function CustomToolbar() {
    return (
        <GridToolbarContainer className={gridClasses.toolbarContainer}>
            <GridToolbarExport />
        </GridToolbarContainer>
    );
}
export default function WaitList() {
    const navigate = useNavigate()
    const location = useLocation()

    const [prpTypes, setPrpTypes] = useState([])
    const [selectedType, setSelectedType] = useState('all')
    const [activeSection, setActiveSection] = useState(null)

    useEffect(() => {
        (async () => {
            const types = await GetPropertyTypes()
            setPrpTypes(types.data.filter(t => t.hasWaitlist === true))
        })()
    }, [])

    const sections = [
        { key: 'active',    label: 'Active Waitlist',        terminalExclude: true,  statuses: [],            showQueue: true,  color: '#3949ab', bg: '#e8eaf6' },
        { key: 'approved',  label: 'Approved Applications',  terminalExclude: false, statuses: ['Approved'],  showQueue: false, color: '#2e7d32', bg: '#e8f5e9' },
        { key: 'denied',    label: 'Denied Applications',    terminalExclude: false, statuses: ['Denied'],    showQueue: false, color: '#c62828', bg: '#ffebee' },
        { key: 'withdrawn', label: 'Withdrawn Applications', terminalExclude: false, statuses: ['Withdrawn'], showQueue: false, color: '#e65100', bg: '#fff3e0' },
    ]

    const active = sections.find(s => s.key === activeSection)

    return <Fragment>
        {location.pathname === '/waitList' && (
            <PageShell>
                <PageHeader
                    title={active ? active.label : 'Waitlist'}
                    back
                    onBack={active ? () => setActiveSection(null) : () => navigate('/')}
                    actions={
                        activeSection === 'active' && selectedType !== 'all' ? (
                            <Action
                                primary
                                icon={<AddCircleIcon />}
                                label="Add to Waitlist"
                                onClick={() => navigate(`/waitList/add/${selectedType}`)}
                            />
                        ) : null
                    }
                />
                <PageContent fill>
                    {!activeSection ? (
                        /* ── Section picker ── */
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mt: 1 }}>
                            {sections.map(section => (
                                <Box
                                    key={section.key}
                                    onClick={() => setActiveSection(section.key)}
                                    sx={{
                                        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                        px: 3, py: 2,
                                        bgcolor: section.bg,
                                        border: `1.5px solid ${section.color}`,
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        userSelect: 'none',
                                        transition: 'box-shadow 0.15s, transform 0.1s',
                                        '&:hover': { boxShadow: `0 2px 8px ${section.color}44`, transform: 'translateY(-1px)' }
                                    }}
                                >
                                    <Typography variant="subtitle1" sx={{ fontWeight: 600, color: section.color }}>
                                        {section.label}
                                    </Typography>
                                    <ArrowRight sx={{ color: section.color }} />
                                </Box>
                            ))}
                        </Box>
                    ) : (
                        /* ── Filtered grid view ── */
                        <>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'flex-end', mb: 2 }}>
                                <Typography variant="body2" sx={{ color: '#666', whiteSpace: 'nowrap' }}>Property Type:</Typography>
                                <NativeSelect
                                    value={selectedType}
                                    onChange={(e) => setSelectedType(e.target.value)}
                                    sx={{ minWidth: 180 }}
                                >
                                    <option value="all">All Types</option>
                                        {prpTypes.map((type) => (
                                        <option key={type._id} value={type._id}>{type.name}</option>
                                    ))}
                                </NativeSelect>
                            </Box>
                            <WaitListGridAll
                                prpTypes={prpTypes}
                                selectedType={selectedType}
                                statuses={active.statuses}
                                terminalExclude={active.terminalExclude}
                                showQueue={active.showQueue}
                                key={`${activeSection}-${selectedType}-${prpTypes.length}`}
                            />
                        </>
                    )}
                </PageContent>
            </PageShell>
        )}
        <Routes>
            <Route path='type/:id' element={<AuthProvider><WaitListGrid /></AuthProvider>} />
            <Route path='add/:id' element={<AuthProvider><AddWaitList /></AuthProvider>} />
            <Route path=':id' element={<AuthProvider><UpdateWaitListApplicant /></AuthProvider>} />
        </Routes>
    </Fragment>
}
const AddWaitList = ()=>{
    const { id } = useParams()
    const [type, setType] = useState(null)
    const navigate = useNavigate()
        
    const schema = yup.object({
        joinedDate: yup.string().trim().required(),
        firstName: yup.string().trim().required(),
        lastName: yup.string().trim().required(),
        phone: yup.string().trim(),
        email: yup.string().email(),
        organization: yup.string().trim(),
        aircrafttype : yup.string().trim()
    }).required() 
    const { control, handleSubmit, formState: { errors }, clearErrors, reset, setError } = useForm({
        defaultValues: {
            joinedDate : '',
            firstName: '',
            lastName: '',
            aircrafttype:'' 
        },
        resolver: yupResolver(schema)
    });
 
    useEffect(() => {
        (async () => {
            const result = await GetPropertyTypes()

            setType(result.data.find((r)=> r._id == id))
        })()
    }, [])

    useEffect(() => {
        clearErrors()
        reset()
    }, [clearErrors, reset])
 
    const onSubmitNoPay= (data)=>{
        (async () => {
            try {
                const idata = { ...data, ...{ propertyType: type._id } }
                const resp = await CreateWaitlistInvoice({}, idata)
                if (resp.data?._id) {
                    handleClose()
                }
            } catch (err) {
                handleErr(err, setError)
            }
        })()
    }
    const isError = (val) => val !== undefined && val !== null && typeof val === 'object'

    
    
    const [open, setOpen] = React.useState(true);
    
    const handleClose = () => {
        navigate("/waitlist/type/"+id)
    };


    return (
            <Dialog fullScreen open={open} onClose={handleClose}>
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            Add WaitList for {type?.name}
                        </Typography>
                         <IconButton edge="start" color="inherit" onClick={handleSubmit(onSubmitNoPay)}>
                            <SaveOutlined />       
                            
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                   
                        
                        <Controller
                        name="aircrafttype"
                        control={control}
                        render={({ field }) => (
                            <TextField
                            variant="standard"
                            margin="dense"
                            error={isError(errors.aircrafttype)}
                            helperText={errors.aircrafttype && errors.aircrafttype.message}
                            fullWidth
                            label="Aircraft Type"
                            {...field}
                            />
                        )}
                        />

                        <Controller
                        name="firstName"
                        control={control}
                        render={({ field }) => (
                            <TextField
                            variant="standard"
                            margin="dense"
                            required
                            error={isError(errors.firstName)}
                            helperText={errors.firstName && errors.firstName.message}
                            fullWidth
                            label="First Name"
                            {...field}
                            />
                        )}
                        />

                        <Controller
                        name="lastName"
                        control={control}
                        render={({ field }) => (
                            <TextField
                            variant="standard"
                            margin="dense"
                            required
                            error={isError(errors.lastName)}
                            helperText={errors.lastName && errors.lastName.message}
                            fullWidth
                            label="Last Name"
                            {...field}
                            />
                        )}
                        />

                        <Controller
                        name="phone"
                        control={control}
                        render={({ field }) => (
                            <TextField
                            variant="standard"
                            margin="dense"
                            error={isError(errors.phone)}
                            helperText={errors.phone && errors.phone.message}
                            fullWidth
                            label="Phone"
                            {...field}
                            />
                        )}
                        />

                        <Controller
                        name="email"
                        control={control}
                        render={({ field }) => (
                            <TextField
                            variant="standard"
                            margin="dense"
                            error={isError(errors.email)}
                            helperText={errors.email && errors.email.message}
                            fullWidth
                            label="Email"
                            {...field}
                            />
                        )}
                        />
                         <LocalizationProvider dateAdapter={AdapterDateFns}>
                                  
                                <Controller name="joinedDate" control={control} render={({ field }) => 
                                    <DatePicker variant='standard' required margin='dense' label='Start Date'
                                     renderInput={(params) =>
                                         <TextField helperText={errors.joinedDate && errors.joinedDate.message} 
                                            fullWidth required variant='standard' {...params} 
                                            error={isError(errors.startDate)} onChange={field.onChange} />} {...field} />} />
              
                         </LocalizationProvider>
                        <Controller
                        name="organization"
                        control={control}
                        render={({ field }) => (
                            <TextField
                            variant="standard"
                            margin="dense"
                            error={isError(errors.organization)}
                            helperText={errors.organization && errors.organization.message}
                            fullWidth
                            label="Organization"
                            {...field}
                            />
                        )}
                        />

                </DialogContent>
                
            </Dialog>
    )
}

function WaitListGridAll({ prpTypes, selectedType, statuses = [], terminalExclude = false, showQueue = true }) {
    const navigate = useNavigate();
    const [chat, setChat] = useState(null);

    const columns = [
        ...(showQueue ? [{ field: 'pos', headerName: '#', flex: 0.4, type: 'number', minVisible: 'xs', align: 'center', headerAlign: 'center' }] : []),
        { field: 'propertyType', headerName: 'Property Type', flex: 0.7, minVisible: 'sm' },
        { field: 'firstName', headerName: 'First Name', flex: 0.7, minVisible: 'xs' },
        { field: 'lastName', headerName: 'Last Name', flex: 0.7, minVisible: 'md' },
        { field: 'joinedDate', headerName: 'Date Joined', flex: 0.6, type: 'date', minVisible: 'lg' },
        { field: 'phone', headerName: 'Phone Number', flex: 0.7, minVisible: 'md' },
        { field: 'email', headerName: 'Email', flex: 0.8, minVisible: 'md' },
        { field: 'organization', headerName: 'Organization', flex: 0.7, minVisible: 'sm' },
        { field: 'status', headerName: 'Status', flex: 0.5, minVisible: 'sm',
            renderCell: (params) => {
                const colors = { 'Submitted': 'default', 'In Progress': 'primary', 'Approved': 'success', 'Denied': 'error', 'Withdrawn': 'warning' }
                return <Chip label={params.value} color={colors[params.value] || 'default'} size="small" />
            }
        },
        {
            field: 'chat', headerName: 'Chat', width: 80, minVisible: 'md', renderCell: (params) => {
                return <IconButton onClick={() => setChat(params.id)}><ChatIcon /></IconButton>
            }
        },
        {
            field: 'view', headerName: 'View', width: 80, minVisible: 'xs', renderCell: (params) => {
                return <IconButton onClick={() => navigate('/waitList/' + params.id)}><ArrowRight /></IconButton>
            }
        }
    ];

    const fetchAllWaitLists = useCallback(async (page, limit, filters, sort) => {
        const result = await GetWaitLists();
        let allWaitlists = result.data || [];

        // Filter by selected property type (only when a specific type is chosen)
        if (selectedType !== 'all') {
            allWaitlists = allWaitlists.filter(item => item.propertyType === selectedType);
        }

        // Only show entries belonging to hasWaitlist property types
        if (prpTypes.length > 0) {
            const waitlistTypeIds = prpTypes.map(t => t._id);
            allWaitlists = allWaitlists.filter(item => waitlistTypeIds.includes(item.propertyType));
        }

        // Filter by the section's statuses
        const TERMINAL_STATUSES = ['Approved', 'Denied', 'Withdrawn']
        if (terminalExclude) {
            // Active Queue: show everything that is NOT a terminal status (catches old values like Unpaid/InProgress too)
            allWaitlists = allWaitlists.filter(item => !TERMINAL_STATUSES.includes(item.status))
        } else {
            allWaitlists = allWaitlists.filter(item => statuses.includes(item.status))
        };

        // Sort active queue by queue number
        if (showQueue) {
            allWaitlists.sort((a, b) => (a.queue || 0) - (b.queue || 0));
        }

        const transformed = allWaitlists.map((e, idx) => {
            const typeObj = prpTypes.find(t => t._id === e.propertyType);
            return {
                ...e,
                id: e._id,
                pos: showQueue ? (selectedType !== 'all' ? e.queue : idx + 1) : undefined,
                joinedDate: moment(e.joinedDate).format('MM/DD/YYYY'),
                propertyType: typeObj ? typeObj.name : 'Unknown'
            };
        });

        const start = (page - 1) * limit;
        const paginatedData = transformed.slice(start, start + limit);

        return {
            data: paginatedData,
            pagination: {
                total: transformed.length,
                page,
                totalPages: Math.ceil(transformed.length / limit)
            }
        };
    }, [selectedType, prpTypes, statuses, showQueue]);

    return (
        <>
            <ResponsiveDataGrid
                columns={columns}
                fetchData={fetchAllWaitLists}
                initialPageSize={10}
                pageSizeOptions={[10, 25, 50, 100]}
                getRowId={(i) => i?._id}
            />
            {chat !== null && <MessageDialog open={chat !== null} handleClose={() => setChat(null)} applicantId={chat} />}
        </>
    );
}

function WaitListGrid() {

    const navigate = useNavigate()
    const [chat, setChat] = useState(null)
    const [prpType, setPrpType] = useState(null)
    const { id } = useParams()

    console.log(id)

    const columns = [
        { field: 'pos', headerName: '#', flex: 0.5, type: 'number', minVisible: 'xs', align: 'center', headerAlign: 'center' },
        { field: 'prpType', headerName: 'Property Type', flex: 0.6, minVisible: 'sm' },
        { field: 'firstName', headerName: 'First Name', flex: 0.5, minVisible: 'xs' },
        { field: 'lastName', headerName: 'Last Name', flex: 0.5, minVisible: 'md' },
        { field: 'joinedDate', headerName: 'Date Joined', flex: 0.5, type: 'date', minVisible: 'lg' },
        { field: 'phone', headerName: 'Phone Number', flex: 0.5, minVisible: 'md' },
        { field: 'email', headerName: 'Email', flex: 0.5, minVisible: 'md' },
        { field: 'organization', headerName: 'Organization', flex: 0.5, minVisible: 'xs' },
        { field: 'status', headerName: 'Status', flex: 0.5, type: 'singleSelect', valueOptions: ['Submitted', 'In Progress', 'Approved', 'Denied', 'Withdrawn'], minVisible: 'sm' },
       
        {
            field: 'chat', headerName: 'Chat', width: 100, minVisible: 'md', renderCell: (params) => {
                return <IconButton onClick={() => setChat(params.id)}><ChatIcon /></IconButton>
            }
        },
        {
            field: 'view', headerName: 'View', width: 100, minVisible: 'xs', renderCell: (params) => {
                return <IconButton onClick={() => handleLink(params.id)}><ArrowRight /></IconButton>
            }
        }
    ];

    useEffect(() => {
        (async () => {
            const types = await GetPropertyTypes()
            const typeofProp = types.data.find(each => each._id === id)
            setPrpType(typeofProp)
        })()
    }, [id])

    const fetchWaitList = useCallback(async (page, limit, filters, sort) => {
        const types = await GetPropertyTypes()
        const typeofProp = types.data.find(each => each._id === id)
        
        const params = {
            page,
            limit
        }
        
        if (Object.keys(filters).length > 0) {
            params.filters = JSON.stringify(filters)
        }
        
        if (sort) {
            params.sort = JSON.stringify(sort)
        }
        
        const result = await GetWaitListByType(id, params);

        if (result.data?.data) {
            const transformed = result.data.data.map((e, idx) => ({
                ...e,
                id: e._id,
                pos: ((page - 1) * limit) + idx + 1,
                joinedDate: moment(e.joinedDate).format('MM/DD/YYYY'),
                prpType: typeofProp ? typeofProp.name : ''
            }));
            return {
                data: transformed,
                pagination: result.data.pagination
            };
        }

        if (Array.isArray(result.data)) {
            const transformed = result.data.map((e, idx) => ({
                ...e,
                id: e._id,
                pos: idx + 1,
                joinedDate: moment(e.joinedDate).format('MM/DD/YYYY'),
                prpType: typeofProp ? typeofProp.name : ''
            }));
            return {
                data: transformed,
                pagination: { total: transformed.length, page: 1, totalPages: 1 }
            };
        }

        return { data: [], pagination: { total: 0, page: 1, totalPages: 0 } };
    }, [id]);

    const handleLink = (id) => navigate('/waitlist/' + id)

    return (
        <PageShell>
            <PageHeader
                title={prpType ? `${prpType.name} Waitlist` : 'Waitlist'}
                back
                onBack={() => navigate('/')}
                actions={
                    Access.isInternal() ? (
                        <Action
                            primary
                            icon={<AddIcon />}
                            label={prpType ? `Add Waitlist for ${prpType.name}` : 'Add Waitlist'}
                            onClick={() => navigate('/waitlist/add/' + id)}
                        />
                    ) : null
                }
            />

            <PageContent fill>
                {chat !== null && <MessageDialog open={chat !== null} handleClose={() => setChat(null)} id={chat} />}
                <ResponsiveDataGrid
                    columns={columns}
                    fetchData={fetchWaitList}
                    initialPageSize={10}
                    pageSizeOptions={[10, 25, 50, 100]}
                />
            </PageContent>
        </PageShell>
    );
}

export function UpdateWaitListApplicant() {
    const { id } = useParams()
    const [data, setData] = useState({})
    const [refresh, setRefresh] = useState(false)
    const [types,setTypes] = useState([])
    const [sendEmailOpen, setSendEmailOpen] = useState(false)
    const getPropertyOptions = () => {
        return [<option key={'NA'}>Please Select</option>].concat(types.map(e => {
            return <option key={e._id} value={e._id} > {e.name}</option>
        }))
    }
    const getStatusOptions = (opts = []) => {
        return [].concat(opts.map((e, idx) => {
            if (typeof e === 'string')
                return <option key={idx} value={e}>{e}</option>
            return <option key={idx} value={e._id}>{e.name}</option>
        }))
    }
    const schema = yup.object({
        joinedDate: yup.string().trim().required(),
        propertyType: yup.string().trim().required(),
        aircrafttype:yup.string().trim(),
        firstName: yup.string().trim().required(),
        lastName: yup.string().trim().required(),
        phone: yup.string().trim(),
        email: yup.string().email(),
        organization: yup.string().trim(),
        status: yup.string().trim().required(),
    }).required() 
    const { control, handleSubmit,setValue, formState: { errors }, clearErrors, reset } = useForm({
        defaultValues: {
            propertyType: '',
            firstName: '',
            lastName: '',
            phone: "",
            email: "",
            organization: "",
            status:"Submitted",
            aircrafttype:"" 
        },
        resolver: yupResolver(schema)
    });
    const navigate = useNavigate()

    const toggleRefresh = () => setRefresh(r => !r)

    useEffect(() => {
        toggleRefresh()
    }, [])

    useEffect(() => {
        (async () => {
            const result = await GetWaitListById(id)
            const res = await GetPropertyTypes()
            setTypes(res.data)
            setData(result.data)
            const fields = ['propertyType', 'firstName', 'lastName', 'email', 'phone',"organization","status","aircrafttype","joinedDate"];
            fields.forEach(field => setValue(field, result.data[field]));
            //setData({ ...result.data, propertyType: res.data.find(each => each._id === result.data.propertyType).name })
            
            
        })()
    }, [refresh, id])

    const addDocument = (doc) => AddDocument(id, doc).then(toggleRefresh)
    const addRemark = (doc) => AddRemark(id, doc).then(toggleRefresh)
   


    const handleDelete = async () => {
        await DeleteWaitListApplicant(data._id)
        navigate('/waitlist')
    }


    const handleAccount = async () => {
        const res = await CreateAccount(data) 
        if (res) navigate('/companies/' + res.data._id)
    }

    const handleSave = async (entity) => {
        const res = await ModifyWaitListApplicant({ ...data, ...entity}) 
        if (res) setData(res.data)
    }

     

    const isError = (val) => val !== undefined && val !== null

    console.log('errors', errors)

    return (
        <>
        <Box>
            <Controller name="propertyType" control={control} 
                render={({ field }) => 
                    <FormControl error={isError(errors.propertyType)} required variant='outlined' disabled={true}
                        margin='dense' fullWidth>
                            <InputLabel style={{left:"-14px"}} margin='dense'>Property Type</InputLabel>
                            <NativeSelect {...field}>{getPropertyOptions()}</NativeSelect>
                            {errors.propertyType && 
                                <FormHelperText>{errors.propertyType.message}</FormHelperText>}
                    </FormControl>} />
                <Controller name="aircrafttype" control={control} 
                    render={({ field }) => 
                        <TextField variant='standard' margin='dense'  error={isError(errors.aircrafttype)}
                             helperText={errors.aircrafttype && errors.aircrafttype.message} fullWidth label='Airctaft Type' 
                                {...field} />} />    
                <Controller name="firstName" control={control} 
                    render={({ field }) => 
                        <TextField variant='standard' margin='dense' required error={isError(errors.firstName)}
                             helperText={errors.firstName && errors.firstName.message} fullWidth label='First Name' 
                                {...field} />} />
                <Controller name="lastName" control={control} 
                    render={({ field }) => 
                        <TextField variant='standard' margin='dense' required error={isError(errors.lastName)} 
                            helperText={errors.lastName && errors.lastName.message} fullWidth label='Last Name' 
                                {...field} />} />
                <Controller name="phone" control={control} 
                    render={({ field }) => 
                        <TextField variant='standard' margin='dense'  
                            error={isError(errors.phone)} helperText={errors.phone && errors.phone.message} 
                                fullWidth label='Phone' {...field} />} />
                <Controller name="email" control={control} 
                    render={({ field }) => <TextField variant='standard' margin='dense'     error={isError(errors.email)} helperText={errors.email && errors.email.message} fullWidth label='Email' {...field} />} />
                 <LocalizationProvider dateAdapter={AdapterDateFns}>
                        
                    <Controller name="joinedDate" control={control} render={({ field }) => 
                        <DatePicker variant='standard' required margin='dense' label='Start Date'
                            renderInput={(params) =>
                                <TextField helperText={errors.joinedDate && errors.joinedDate.message} 
                                fullWidth required variant='standard' {...params} 
                                error={isError(errors.startDate)} onChange={field.onChange} />} {...field} />} />
    
                </LocalizationProvider>
                <Controller name="organization" control={control} 
                    render={({ field }) => 
                        <TextField variant='standard' margin='dense'   
                             error={isError(errors.organization)} 
                             helperText={errors.organization && errors.organization.message} fullWidth 
                             label='Organization' {...field} />} />
                <Controller name="status" control={control} 
                    render={({ field }) => 
                        <FormControl error={isError(errors.status)} required variant='outlined' 
                            margin='dense' fullWidth>
                                <InputLabel style={{left:"-14px"}} margin='dense'>Status</InputLabel>
                                <NativeSelect {...field}>{getStatusOptions(['Submitted', 'In Progress', 'Approved', 'Denied', 'Withdrawn'])}</NativeSelect>
                                {errors.status && 
                                    <FormHelperText>{errors.status.message}</FormHelperText>}
                        </FormControl>} />
 

                <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(auto-fit, minmax(130px, 1fr))' }, gap: 1, mt: 2 }}>
                        <Button variant='outlined' startIcon={<SaveIcon />} onClick={handleSubmit(handleSave)}>Save</Button>
                        <Documents docIds={data.documents} onUpload={res => addDocument(res._id)} module="Waitlist" buttonProps={{ variant: 'outlined', fullWidth: true }} />
                        <Remarks docIds={data.remarks} onUpload={res => addRemark(res._id)} module="Waitlist" buttonProps={{ variant: 'outlined', fullWidth: true }} />
                        <Button variant='outlined' startIcon={<EmailIcon />} onClick={() => setSendEmailOpen(true)}>Send Email</Button>
                        <Button variant='outlined' startIcon={<DeleteIcon />} onClick={handleDelete}>Delete Applicant</Button>
                        <Button variant='outlined' startIcon={<AddCircleIcon />} onClick={handleAccount}>Create Account</Button>
                        <Button variant='outlined' onClick={() => navigate(-1)} startIcon={<BackIcon />}>Back</Button>
                </Box>
        </Box>

        <SendTemplateDialog
            open={sendEmailOpen}
            onClose={() => setSendEmailOpen(false)}
            module="Waitlist"
            entityId={id}
            defaultEmail={data.email || ''}
        />
        </>
    )


}

